export const DoctorAvatar = ({ className = "" }) => (
  <svg viewBox="0 0 160 160" className={className} role="img" aria-label="Doctor avatar">
    <circle cx="80" cy="80" r="80" fill="#DCE4E8" />
    <circle cx="80" cy="58" r="26" fill="#F0C9A6" />
    <path d="M80 30c-16 0-27 11-27 27 0 4 1 8 2 11-3-16 7-26 25-26s28 10 25 26c1-3 2-7 2-11 0-16-11-27-25-27z" fill="#3d4a52" />
    <path d="M36 160c0-30 20-48 44-48s44 18 44 48z" fill="#FFFFFF" />
    <path d="M36 160c0-30 20-48 44-48s44 18 44 48z" fill="#14717A" opacity="0.12" />
    <path d="M80 112l-10 14 10 34 10-34z" fill="#4CA6AF" />
    <path d="M62 118c-6 2-10 8-10 15v8" stroke="#14717A" strokeWidth="4" fill="none" strokeLinecap="round" />
    <path d="M98 118c6 2 10 8 10 15v4a8 8 0 0016 0v-2" stroke="#14717A" strokeWidth="4" fill="none" strokeLinecap="round" />
    <circle cx="52" cy="144" r="6" fill="#14717A" />
    <circle cx="124" cy="131" r="4" fill="#14717A" />
  </svg>
);
